export default __webpack_public_path__ + "static/media/btc.995f1e67.png";